/* 2026-10-19 · GALLERY ZOOM (CODE_TASK_PDP_GALLERY_ZOOM_2026-10-19).
   Zoom for the PDP lightbox ([data-pdp-gallery-lightbox]), on top of whatever
   opens it (pdp-gallery.js, both gallery paths). No library.
     Desktop  click toggles 1x <-> 2.5x at the pointer; while zoomed the image
              follows the mouse.
     Touch    double-tap toggles 1x <-> 2.5x at the finger; pinch zooms 1x-4x;
              one finger pans while zoomed; a horizontal swipe at 1x changes
              slide (the lightbox's own prev/next buttons).
   Zoom resets whenever the image changes or the lightbox closes. The image is
   moved with a CSS transform only, so the page layout never changes.
   REVERT: delete this file, its <script> in sections/product-archive-main.liquid
   and the GALLERY ZOOM <style> block in snippets/pdp-gallery.liquid. */
(function () {
  'use strict';
  var STEP = 2.5, MAX = 4, TAP_MS = 300, TAP_PX = 30, SWIPE_PX = 50;

  function init(lb) {
    if (lb.__heZoom) return;
    lb.__heZoom = true;
    var img = lb.querySelector('[data-pdp-gallery-lightbox-image]');
    if (!img) return;
    var prev = lb.querySelector('[data-pdp-gallery-lightbox-prev]');
    var next = lb.querySelector('[data-pdp-gallery-lightbox-next]');
    var s = 1, tx = 0, ty = 0;
    var base = null;                 // unscaled image box (viewport coords)
    var pts = {};                    // active pointers
    var pinch = null, pan = null, down = null, lastTap = null;

    function vw() { return window.innerWidth; }
    function vh() { return window.innerHeight; }
    function measure() {
      var t = img.style.transform; img.style.transform = 'none';
      var r = img.getBoundingClientRect(); img.style.transform = t;
      base = { cx: r.left + r.width / 2, cy: r.top + r.height / 2, w: r.width, h: r.height };
    }
    function range(size, c, view) { // allowed translation for one axis at scale s
      var scaled = size * s;
      if (scaled <= view) return [view / 2 - c, view / 2 - c];
      return [view - c - scaled / 2, scaled / 2 - c];
    }
    function clamp() {
      var rx = range(base.w, base.cx, vw()), ry = range(base.h, base.cy, vh());
      if (s === 1) { tx = 0; ty = 0; return; }
      tx = Math.min(rx[1], Math.max(rx[0], tx));
      ty = Math.min(ry[1], Math.max(ry[0], ty));
    }
    function apply(animate) {
      img.style.transition = animate ? 'transform 180ms ease' : 'none';
      img.style.transform = s === 1 ? '' : 'translate(' + tx + 'px,' + ty + 'px) scale(' + s + ')';
      lb.classList.toggle('is-zoomed', s > 1);
      img.setAttribute('data-zoom', String(Math.round(s * 100) / 100));
    }
    function zoomAt(px, py, s1, animate) { // keep the point under the pointer still
      if (!base || s === 1) measure();
      var s0 = s;
      s1 = Math.max(1, Math.min(MAX, s1));
      tx = (px - base.cx) - (px - base.cx - tx) * (s1 / s0);
      ty = (py - base.cy) - (py - base.cy - ty) * (s1 / s0);
      s = s1;
      clamp(); apply(animate);
    }
    function follow(mx, my) { // desktop: the zoomed image follows the mouse
      var rx = range(base.w, base.cx, vw()), ry = range(base.h, base.cy, vh());
      tx = rx[1] - (mx / vw()) * (rx[1] - rx[0]);
      ty = ry[1] - (my / vh()) * (ry[1] - ry[0]);
      apply(false);
    }
    // Size the image to fill the viewport (full height on desktop, full width on a
    // phone) from its aspect ratio. naturalWidth is not used as a pixel size:
    // WebKit corrects it by the JPEG's EXIF resolution, which shrank the image.
    function fit() {
      if (!img.naturalWidth || !img.naturalHeight) return;
      var r = img.naturalWidth / img.naturalHeight, w = vw(), h = w / r;
      if (h > vh()) { h = vh(); w = h * r; }
      img.style.width = Math.round(w) + 'px'; img.style.height = Math.round(h) + 'px';
      base = null;
    }
    img.addEventListener('load', fit);
    function reset() { s = 1; tx = 0; ty = 0; pts = {}; pinch = pan = down = lastTap = null; apply(false); }

    // a new image, or the lightbox hidden/shown, resets zoom
    new MutationObserver(reset).observe(img, { attributes: true, attributeFilter: ['src'] });
    new MutationObserver(function () { if (lb.hasAttribute('hidden')) reset(); }).observe(lb, { attributes: true, attributeFilter: ['hidden'] });
    window.addEventListener('resize', function () { fit(); if (s > 1) { measure(); clamp(); apply(false); } });
    new MutationObserver(function () { if (!lb.hasAttribute('hidden')) fit(); }).observe(lb, { attributes: true, attributeFilter: ['hidden'] });
    // iOS Safari: keep the page itself from pinch-zooming behind the lightbox
    lb.addEventListener('gesturestart', function (e) { e.preventDefault(); });

    img.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      e.preventDefault();
      try { img.setPointerCapture(e.pointerId); } catch (_e) {}
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pts);
      if (ids.length === 2 && e.pointerType !== 'mouse') {
        var a = pts[ids[0]], b = pts[ids[1]];
        if (s === 1) measure();
        pinch = { d: Math.hypot(a.x - b.x, a.y - b.y) || 1, s: s };
        pan = null; down = null;
      } else if (ids.length === 1) {
        down = { x: e.clientX, y: e.clientY, t: Date.now(), type: e.pointerType };
        pan = { x: e.clientX, y: e.clientY, tx: tx, ty: ty };
      }
    });
    img.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'mouse') {
        if (s > 1 && !pts[e.pointerId]) follow(e.clientX, e.clientY);
        return;
      }
      if (!pts[e.pointerId]) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pts);
      if (pinch && ids.length >= 2) {
        var a = pts[ids[0]], b = pts[ids[1]];
        var d = Math.hypot(a.x - b.x, a.y - b.y);
        zoomAt((a.x + b.x) / 2, (a.y + b.y) / 2, pinch.s * d / pinch.d, false);
      } else if (pan && s > 1) {
        tx = pan.tx + (e.clientX - pan.x); ty = pan.ty + (e.clientY - pan.y);
        clamp(); apply(false);
      }
    });
    function end(e) {
      if (!pts[e.pointerId]) return;
      delete pts[e.pointerId];
      var left = Object.keys(pts).length;
      if (pinch && left < 2) {
        pinch = null;
        if (s < 1.05) { s = 1; clamp(); apply(true); }
        if (left === 1) { var id = Object.keys(pts)[0]; pan = { x: pts[id].x, y: pts[id].y, tx: tx, ty: ty }; }
        return;
      }
      if (!down || left) return;
      var dx = e.clientX - down.x, dy = e.clientY - down.y, moved = Math.hypot(dx, dy);
      if (down.type === 'mouse') {
        if (moved < 6) { // click toggles at the pointer
          if (s > 1) { s = 1; tx = ty = 0; apply(true); }
          else { zoomAt(e.clientX, e.clientY, STEP, true); follow(e.clientX, e.clientY); }
        }
      } else if (s === 1 && Math.abs(dx) > SWIPE_PX && Math.abs(dx) > Math.abs(dy) * 1.5) {
        var btn = dx < 0 ? next : prev;   // swipe changes slide only at 1x
        if (btn) btn.click();
        lastTap = null;
      } else if (moved < TAP_PX) {
        var now = Date.now();
        if (lastTap && now - lastTap.t < TAP_MS && Math.hypot(e.clientX - lastTap.x, e.clientY - lastTap.y) < TAP_PX) {
          if (s > 1) { s = 1; tx = ty = 0; apply(true); } else zoomAt(e.clientX, e.clientY, STEP, true);
          lastTap = null;
        } else lastTap = { t: now, x: e.clientX, y: e.clientY };
      }
      down = null; pan = null;
    }
    img.addEventListener('pointerup', end);
    img.addEventListener('pointercancel', end);
    // a click on the image must never reach the backdrop's close handler
    img.addEventListener('click', function (e) { e.stopPropagation(); });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pdp-gallery-lightbox]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
